module.exports = __webpack_public_path__ + "img/ic_download_white.6fe06aa1.svg";